import {Component, EventEmitter, inject, Input, OnInit, Output, ChangeDetectionStrategy} from '@angular/core';

import {ProductState} from "../../enums/product-state";
import {CardComponent} from "../card/card.component";
import {ProductSubType} from "../../types/product-sub.type";
import {BadgeComponent} from "../badge/badge.component";
import {ButtonComponent} from "../button/button.component";
import {CurrencyComponent} from "../currency/currency.component";
import {DividerComponent} from "../divider/divider.component";
import {ProductPriceDisplayComponent} from "../product-price-display/product-price-display.component";
import Product from "../../model/product.model";
import {ApplicationConfig, config} from "../../../../config";
import {AuthService} from "../../services/auth.service";
import Subscription from "../../model/subscription.model";

@Component({
  selector: 'app-product-card',
  templateUrl: './product-card.component.html',
  imports: [
      CardComponent,
      BadgeComponent,
      ButtonComponent,
      CurrencyComponent,
      DividerComponent,
      ProductPriceDisplayComponent
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './product-card.component.scss'
})
export class ProductCardComponent implements OnInit {
  private readonly authService: AuthService = inject(AuthService);
  protected readonly ProductState: typeof ProductState = ProductState;
  protected readonly ProductSubType: typeof ProductSubType = ProductSubType;

  @Input() product!: Product;
  @Output() toBeOrdered: EventEmitter<Product> = new EventEmitter<Product>();

  protected readonly config: ApplicationConfig = config;
  protected selectedSubscription: Subscription | null = null;

  public ngOnInit(): void {
    this.authService.getSelectedSubscription().subscribe((subscription: Subscription | null): void => {
      this.selectedSubscription = subscription;
    });
  }

  public getInternetSpeed(): number {
    // @ToDo: fix these lines to check te instance of product
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    return this.product.specs['speed'] ?? 0;
  }

  public getFeatures(): { icon: string; text: string; }[] {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    return this.product.specs['features'] ?? [];
  }

  public getProductIcon(): string {

    return this.product.specs['icon'] ?? '';
  }
}
